import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { ReportePerformComponent } from './views/reporte-perform/reporte-perform.component';
import { MantenedorOrdenProcesoPerformComponent } from './views/mantenedor-ordenproceso-perform/mantenedor-ordenproceso-perform.component';
import { ReportePerformSendedComponent } from './views/reporte-perform-sended/reporte-perform-sended.component';
import { ReportePerformDetailComponent } from './views/reporte-perform-detail/reporte-perform-detail.component';
import { ReporteGaussComponent } from './views/reporte-gauss/reporte-gauss.component';
import { MantenedorProductoSpecsComponent } from './views/mantenedor-producto-specs/mantenedor-producto-specs.component';
import { MantenedorProductoLogsComponent } from './views/mantenedor-producto-logs/mantenedor-producto-logs.component';
import { ReporteParetoComponent } from './views/reporte-pareto/reporte-pareto.component';
import { BitacoraSeguimientoPerformComponent } from './views/bitacora-seguimiento-perform/bitacora-seguimiento-perform.component';
import { MantenedorBalanzadeLineaComponent } from './views/mantenedor-balanzade-linea/mantenedor-balanzade-linea.component';
import { CapturadorPesoComponent } from './views/capturador-peso/capturador-peso.component';


const finanzasRoutes: Routes = [
  //cobros-autoservicios
  {path: 'perform/reportes', component: ReportePerformComponent}, //canActivate: [AuthGuard]},
  {path: 'tvc/integracion/perform-solicitar-ordenproceso',component: MantenedorOrdenProcesoPerformComponent},
  {path: 'perform/reportes-procesado',component: ReportePerformSendedComponent},
  {path: 'perform/reportes-detail',component: ReportePerformDetailComponent},
  {path: 'perform/reportes-gauss',component: ReporteGaussComponent},
  {path: 'perform/reportes-pareto',component: ReporteParetoComponent},
  {path: 'perform/mantenedor-producto-especificaciones',component:MantenedorProductoSpecsComponent},
  {path: 'perform/envio-productos-perform',component:MantenedorProductoLogsComponent},

  //LOG SEGUIMIENTO Ticket 30238 LOG de ingreso en modulos perform
  {path: 'perform/reporte-seguimiento', component: BitacoraSeguimientoPerformComponent},

  //KD: Ticket 24557 Balanza Gramera
  {path: 'lineas/mantener-balanzas', component: MantenedorBalanzadeLineaComponent},
  {path: 'lineas/captura-pesos', component: CapturadorPesoComponent},

];

@NgModule({
  imports: [RouterModule.forChild(finanzasRoutes)],
  exports: [RouterModule]
})
export class PerformModule {
}
